import { useState } from 'react'

import Styles from './Gifs.module.scss'
import ImageMenuModalStyles from '../ImageMenuModal.module.scss'

import { Modal } from 'almanac-ui/Modal'
import { useDebounce } from 'hooks/useDebounce'
import { useGiphy } from 'hooks/queries/useGiphy'
import { SearchField } from 'components/ImagePickerModal/SearchField/SearchField'
import { ScrollContainer } from 'components/ImagePickerModal/ScrollContainer/ScrollContainer'
import { Grid } from 'components/ImagePickerModal/Grid/Grid'
import { MediaFileThumbnail } from 'components/ImagePickerModal/ImageThumbnail/MediaFileThumbnail'
import { useImageMenuContext } from '../ImageMenuContext'
import InfiniteScroll from 'common/InfiniteScroll/InfiniteScroll'
import { Actions } from '../ImageMenuModal'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const Gifs = () => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { toggleSelectedImage, selectedImages, setProvider } = useImageMenuContext()
  const [query, setQuery] = useState('')
  const debouncedQuery = useDebounce(query, 500)
  const { data, fetchNextPage, hasNextPage } = useGiphy({
    query: debouncedQuery,
    perPage: 24,
  })
  const results = (data?.pages || []).flatMap((page) => page.data)

  const images = results.map((item) => ({
    url: item.images.original.url,
  }))

  return (
    <>
      <Modal.Header
        className={ImageMenuModalStyles.header}
        actions={<Actions />}
        title="Insert GIFs"
        onBack={() => setProvider('')}
      />
      <div className={Styles.searchContainer}>
        <SearchField value={query} onChange={setQuery} />
      </div>
      <Modal.Content className={Styles.content} withoutFooter={isSystemRedesignEnabled}>
        <div className={Styles.gifs} data-testid="gifs-provider">
          <ScrollContainer>
            <Grid.Root>
              {images.map((image, i) => (
                <Grid.Thumbnail key={`${image.url}-${i}`}>
                  <MediaFileThumbnail
                    mediaFile={image}
                    onToggleSelect={(image) => toggleSelectedImage({ ...image, provider: 'gifs' })}
                    isSelected={selectedImages.some((i) => i.url === image.url)}
                  />
                </Grid.Thumbnail>
              ))}
            </Grid.Root>
            {hasNextPage && (
              <div className={Styles.infiniteLoader}>
                <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage} />
              </div>
            )}
          </ScrollContainer>
        </div>
      </Modal.Content>
    </>
  )
}
